import { render, staticRenderFns } from "./VDesigner.vue?vue&type=template&id=6a74a21c&"
import script from "./VDesigner.vue?vue&type=script&lang=js&"
export * from "./VDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports